var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mail-editor" },
    [
      _c("div", { staticClass: "editor-toolbar" }, [
        _c(
          "div",
          { staticClass: "toolbar-group" },
          [
            _c(
              "a-tooltip",
              {
                attrs: {
                  placement: "top",
                  title: _vm.$t("mail.stringFormats"),
                },
              },
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: {
                      xxsmall: "",
                      primary: _vm.showFormatTools,
                      classNames: "square-button text-button",
                    },
                    on: { click: _vm.toggleFormatTools },
                  },
                  [_vm._v("\n                    A\n                ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showFormatTools
              ? _c("div", { staticClass: "format-tools" }, [
                  _c(
                    "div",
                    { staticClass: "format-section" },
                    [
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            placement: "top",
                            title: _vm.$t("mail.bold"),
                          },
                        },
                        [
                          _c("SupsisButton", {
                            class: { active: _vm.isEditorActive("bold") },
                            attrs: {
                              icon: "format_bold",
                              primary: _vm.isEditorActive("bold"),
                              xxsmall: "",
                              classNames: "square-button",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditorCommand("bold")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            placement: "top",
                            title: _vm.$t("mail.italic"),
                          },
                        },
                        [
                          _c("SupsisButton", {
                            class: { active: _vm.isEditorActive("italic") },
                            attrs: {
                              icon: "format_italic",
                              primary: _vm.isEditorActive("italic"),
                              xxsmall: "",
                              classNames: "square-button",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditorCommand("italic")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            placement: "top",
                            title: _vm.$t("mail.underline"),
                          },
                        },
                        [
                          _c("SupsisButton", {
                            class: { active: _vm.isEditorActive("underline") },
                            attrs: {
                              icon: "format_underlined",
                              primary: _vm.isEditorActive("underline"),
                              xxsmall: "",
                              classNames: "square-button",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditorCommand("underline")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "divider-vertical" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "format-section" },
                    [
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            placement: "top",
                            title: _vm.$t("mail.fontFamily"),
                          },
                        },
                        [
                          _c(
                            "a-dropdown",
                            {
                              attrs: {
                                trigger: ["click"],
                                placement: "bottomLeft",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "overlay",
                                    fn: function () {
                                      return [
                                        _c(
                                          "a-menu",
                                          [
                                            _c(
                                              "a-menu-item",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleEditorCommand(
                                                      "paragraph"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                       " +
                                                    _vm._s(
                                                      _vm.$t("mail.normalText")
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-menu-item",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleEditorCommand(
                                                      "heading",
                                                      { level: 1 }
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t("message.title")
                                                    ) +
                                                    " 1\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-menu-item",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleEditorCommand(
                                                      "heading",
                                                      { level: 2 }
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t("message.title")
                                                    ) +
                                                    " 2\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-menu-item",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleEditorCommand(
                                                      "heading",
                                                      { level: 3 }
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t("message.title")
                                                    ) +
                                                    " 3\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3300205566
                              ),
                            },
                            [
                              _c("SupsisButton", {
                                attrs: {
                                  icon: "text_fields",
                                  xxsmall: "",
                                  classNames: "square-button",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            placement: "top",
                            title: _vm.$t("mail.textColor"),
                          },
                        },
                        [
                          _c(
                            "a-dropdown",
                            {
                              attrs: {
                                trigger: ["click"],
                                placement: "bottomLeft",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "overlay",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "color-picker" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "color-options" },
                                              _vm._l(
                                                _vm.colorOptions,
                                                function (color) {
                                                  return _c("div", {
                                                    key: color.value,
                                                    staticClass: "color-option",
                                                    style: {
                                                      backgroundColor:
                                                        color.value,
                                                    },
                                                    attrs: {
                                                      title: color.name,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setTextColor(
                                                          color.value
                                                        )
                                                      },
                                                    },
                                                  })
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2299467449
                              ),
                            },
                            [
                              _c("SupsisButton", {
                                attrs: {
                                  icon: "format_color_text",
                                  xxsmall: "",
                                  classNames: "square-button",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "divider-vertical" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "format-section" },
                    [
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            placement: "top",
                            title: _vm.$t("mail.alignLeft"),
                          },
                        },
                        [
                          _c("SupsisButton", {
                            class: {
                              active: _vm.isEditorActive({ textAlign: "left" }),
                            },
                            attrs: {
                              icon: "format_align_left",
                              primary: _vm.isEditorActive({
                                textAlign: "left",
                              }),
                              xxsmall: "",
                              classNames: "square-button",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditorCommand(
                                  "textAlign",
                                  "left"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            placement: "top",
                            title: _vm.$t("mail.alignCenter"),
                          },
                        },
                        [
                          _c("SupsisButton", {
                            class: {
                              active: _vm.isEditorActive({
                                textAlign: "center",
                              }),
                            },
                            attrs: {
                              icon: "format_align_center",
                              primary: _vm.isEditorActive({
                                textAlign: "center",
                              }),
                              xxsmall: "",
                              classNames: "square-button",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditorCommand(
                                  "textAlign",
                                  "center"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            placement: "top",
                            title: _vm.$t("mail.alignRight"),
                          },
                        },
                        [
                          _c("SupsisButton", {
                            class: {
                              active: _vm.isEditorActive({
                                textAlign: "right",
                              }),
                            },
                            attrs: {
                              icon: "format_align_right",
                              primary: _vm.isEditorActive({
                                textAlign: "right",
                              }),
                              xxsmall: "",
                              classNames: "square-button",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditorCommand(
                                  "textAlign",
                                  "right"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "divider" }),
            _vm._v(" "),
            !_vm.showFormatTools
              ? _c(
                  "div",
                  { staticClass: "other-tools" },
                  [
                    !_vm.inlineTextOnly
                      ? _c(
                          "a-tooltip",
                          { attrs: { placement: "top", title: "Dosya Yükle" } },
                          [
                            _c("SupsisButton", {
                              attrs: {
                                icon: "image",
                                xxsmall: "",
                                classNames: "square-button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("image-upload")
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.inlineTextOnly
                      ? _c("span", { staticClass: "divider" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.editor && !_vm.editor.state.selection.empty
                      ? _c(
                          "a-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              title: _vm.$t("message.addLink"),
                            },
                          },
                          [
                            _c(
                              "a-popover",
                              {
                                attrs: {
                                  placement: "bottom",
                                  trigger: "click",
                                  overlayClassName: "link-popover-container",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "content",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "link-form" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c("a-input", {
                                                    attrs: {
                                                      placeholder: "https://",
                                                    },
                                                    on: {
                                                      keydown: function (
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        ) {
                                                          return null
                                                        }
                                                        return _vm.applyLink.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.linkUrl,
                                                      callback: function ($$v) {
                                                        _vm.linkUrl = $$v
                                                      },
                                                      expression: "linkUrl",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-group form-actions",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "action-buttons",
                                                    },
                                                    [
                                                      _c(
                                                        "SupsisButton",
                                                        {
                                                          attrs: {
                                                            classNames:
                                                              "form-button",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.hideLinkPopover,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "mail.cancel"
                                                                )
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.isEditorActive("link")
                                                        ? _c(
                                                            "SupsisButton",
                                                            {
                                                              attrs: {
                                                                danger: "",
                                                                classNames:
                                                                  "form-button",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.removeLink,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                            " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "settings.remove"
                                                                    )
                                                                  ) +
                                                                  "\n                                        "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "SupsisButton",
                                                        {
                                                          attrs: {
                                                            primary: "",
                                                            classNames:
                                                              "form-button",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.applyLink,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "ticimax.apply"
                                                                )
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1236007138
                                ),
                                model: {
                                  value: _vm.showLinkPopover,
                                  callback: function ($$v) {
                                    _vm.showLinkPopover = $$v
                                  },
                                  expression: "showLinkPopover",
                                },
                              },
                              [
                                _vm._v(" "),
                                _c("SupsisButton", {
                                  class: { active: _vm.isEditorActive("link") },
                                  attrs: {
                                    icon: "link",
                                    primary: _vm.isEditorActive("link"),
                                    xxsmall: "",
                                    classNames: "square-button",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          placement: "top",
                          title: _vm.$t("mail.addEmoji"),
                        },
                      },
                      [
                        _c("EmojiButton", {
                          attrs: { "on-emoji-picked": _vm.addEmoji },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button",
                                fn: function () {
                                  return [
                                    _c("SupsisButton", {
                                      attrs: {
                                        icon: "mood",
                                        xxsmall: "",
                                        classNames: "square-button",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2356852358
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.hideAIAssistant
                      ? _c(
                          "a-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              title: _vm.$t("plans.aiAssistant"),
                            },
                          },
                          [
                            _c("SupsisButton", {
                              attrs: {
                                icon: "psychology",
                                xxsmall: "",
                                classNames: "square-button",
                              },
                              on: { click: _vm.showAIAssistant },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "toolbar-spacer" }),
            _vm._v(" "),
            _c(
              "a-tooltip",
              { attrs: { placement: "top", title: _vm.$t("mail.takeItBack") } },
              [
                _c("SupsisButton", {
                  attrs: {
                    icon: "undo",
                    xxsmall: "",
                    classNames: "square-button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleEditorCommand("undo")
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-tooltip",
              {
                attrs: { placement: "top", title: _vm.$t("mail.fastForward") },
              },
              [
                _c("SupsisButton", {
                  attrs: {
                    icon: "redo",
                    xxsmall: "",
                    classNames: "square-button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleEditorCommand("redo")
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.editor
        ? _c("editor-content", {
            staticClass: "tiptap-editor",
            attrs: { editor: _vm.editor },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showFloatingToolbar
        ? _c(
            "div",
            {
              staticClass: "floating-toolbar",
              style: _vm.floatingToolbarStyle,
            },
            [
              _c(
                "a-tooltip",
                { attrs: { placement: "top", title: _vm.$t("mail.bold") } },
                [
                  _c("SupsisButton", {
                    class: { active: _vm.isEditorActive("bold") },
                    attrs: {
                      icon: "format_bold",
                      primary: _vm.isEditorActive("bold"),
                      xxsmall: "",
                      classNames: "square-button",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleEditorCommand("bold")
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-tooltip",
                { attrs: { placement: "top", title: _vm.$t("mail.italic") } },
                [
                  _c("SupsisButton", {
                    class: { active: _vm.isEditorActive("italic") },
                    attrs: {
                      icon: "format_italic",
                      primary: _vm.isEditorActive("italic"),
                      xxsmall: "",
                      classNames: "square-button",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleEditorCommand("italic")
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-tooltip",
                {
                  attrs: { placement: "top", title: _vm.$t("mail.underline") },
                },
                [
                  _c("SupsisButton", {
                    class: { active: _vm.isEditorActive("underline") },
                    attrs: {
                      icon: "format_underlined",
                      primary: _vm.isEditorActive("underline"),
                      xxsmall: "",
                      classNames: "square-button",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleEditorCommand("underline")
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.hideAIAssistant
                ? _c(
                    "a-tooltip",
                    {
                      attrs: {
                        placement: "top",
                        title: _vm.$t("plans.aiAssistant"),
                      },
                    },
                    [
                      _c("SupsisButton", {
                        attrs: {
                          icon: "psychology",
                          xxsmall: "",
                          classNames: "square-button",
                        },
                        on: { click: _vm.showAIAssistant },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tooltipVisible
        ? _c(
            "div",
            { staticClass: "toolbar-tooltip", style: _vm.tooltipStyle },
            [_vm._v("\n        " + _vm._s(_vm.tooltipText) + "\n    ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }